// Import sharp duotone icons from your custom kit
import {
  faCamera,
  faSpinner,
  faExclamationTriangle,
  faChevronLeft,
  faChevronRight,
  faRedoAlt,
  faPlus,
  faTimes,
  faSearch,
  faQuestionCircle,
  faBars,
  faCogs,
  faCog,
  faCopy,
  faExpandArrowsAlt,
  faCompressArrowsAlt,
  faCalendarAlt,
  faCheck,
  faDownload,
  faHome,
  faArrowLeft,
  faCircleCheck,
  faVideo
} from '@awesome.me/kit-fe06945d58/icons/sharp-duotone/solid';

export class Icons {
  backArrow = faArrowLeft;
  home = faHome;
  camera = faCamera;
  spinner = faSpinner;
  exclamation = faExclamationTriangle;
  previous = faChevronLeft;
  next = faChevronRight;
  refresh = faRedoAlt;
  add = faPlus;
  times = faTimes;
  search = faSearch;
  questionMark = faQuestionCircle;
  bars = faBars;
  cogs = faCogs;
  cog = faCog;
  fullscreen = faExpandArrowsAlt;
  exitFullscreen = faCompressArrowsAlt;
  calendar = faCalendarAlt;
  check = faCheck;
  download = faDownload;
  copy = faCopy;
  circleCheck = faCircleCheck;
  video = faVideo;
  constructor() { }
}
